module.exports = __webpack_public_path__ + "img/bv.b70ab2f2.svg";